export default "__VITE_ASSET__BOaAExIU__"